import React from 'react';
import { Box, Typography, IconButton, Divider } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

interface PanelShellProps {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
  // 移动端详情:外层已有返回顶栏,隐藏自带头部(只保留内容)
  embedded?: boolean;
}

// 右侧详情区统一外壳:顶部标题栏(深色)+ 可滚动内容区(浅色)
export default function PanelShell({ title, onClose, children, footer, embedded }: PanelShellProps) {
  return (
    <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', minWidth: 0, bgcolor: '#f0f1f5' }}>
      {!embedded && (
        <>
          <Box
            sx={{
              height: 56,
              px: 2,
              display: 'flex',
              alignItems: 'center',
              bgcolor: 'primary.main',
              color: '#fff',
              flexShrink: 0,
            }}
          >
            <Typography sx={{ fontWeight: 600, fontSize: 15 }}>{title}</Typography>
            <Box sx={{ flexGrow: 1 }} />
            <IconButton onClick={onClose} sx={{ color: '#fff' }} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
          <Divider />
        </>
      )}
      <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>{children}</Box>
      {footer && <Divider />}
      {footer && <Box sx={{ p: 1.5, bgcolor: '#fff' }}>{footer}</Box>}
    </Box>
  );
}
